(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primed-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  var btn = document.getElementById('mn-notify-open');
  var slot = document.getElementById('mn-notify-slot');
  if (!btn || !slot) return;
  btn.addEventListener('click', function () {
    slot.classList.add('is-open');
    var real = slot.querySelector('.sndv_bkstk_notify_btn');
    if (real) real.click();
    var form = slot.querySelector('[data-section="form"]');
    if (form) {
      form.style.display = 'block';
      form.classList.remove('chp_hidden');
    }
    btn.setAttribute('hidden', 'hidden');
  });
})();

  } catch(e) { console.error(e); }
})();
})();
